import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function PageTransition({
  children,
  fill = false,
}: {
  children: React.ReactNode;
  fill?: boolean;
}) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{
          duration: 0.36,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={{
          width: "100%",
          ...(fill
            ? {
                // Let layout routes make short pages claim remaining viewport
                // height without hardcoding navbar measurements.
                //
                // flexDirection must be explicit: flexbox defaults to "row", which
                // turns the single child into a row-direction flex item sized by
                // shrink-to-fit content width instead of stretching to 100%. On any
                // viewport wider than the widest maxW-capped descendant (e.g. the
                // navbar's 1512px inner container), that left the page flush-left
                // with a blank gap on the right.
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
              }
            : null),
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
